export default __webpack_public_path__ + "static/media/backend.55d63db2.webp";